import * as React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface IconBoxProps {
    color: string;
    icon: React.ReactNode;
    containerStyle?: SxProps<Theme>;
    onClick?: () => void; 
}

export const IconBox: React.FC<IconBoxProps> = ({ color, icon, containerStyle, onClick }) => {
    return (
        <Box
            sx={{
                border: `1px solid ${color}`,
                borderRadius: '4px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '8px',
                cursor: onClick ? 'pointer' : 'default',
                ...containerStyle
            }}
            onClick={onClick} 
        >
            {icon}
        </Box>
    );
};
